export default __webpack_public_path__ + "static/media/ASSEMBLY POKOYOKE SYSTEM.f7f0ee6a.png";